angular.module('elogbooksServices').service('quoteAdvancedFiltersModal', ['$uibModal', 'advancedFilterService', function ($uibModal, advancedFilterService) {
    return {
        open: function (collections, resources, config) {
            return $uibModal.open({
                templateUrl: '/modules/common/modals/advancedFilters/modal-advanced-filters-modal.html',
                size: 'xl',
                controller: 'advancedQuoteFiltersModalController',
                controllerAs: 'vm',
                resolve: {
                    config: function () {
                        var defaultConfig = {
                            view: 'quote',
                            titleMessage: 'ARE_YOU_SURE_HEADER',
                            bodyMessage: 'ARE_YOU_SURE'
                        };

                        return angular.extend({}, defaultConfig, config);
                    },
                    rootResource: resources.root,
                    priorityCollectionResponse: collections[0],
                    operativeCollectionResponse: advancedFilterService.getFilterData('quote-operatives',resources),
                    approversCollectionResponse: advancedFilterService.getFilterData('approvers',resources),
                    quoteValueApproversCollectionResponse: advancedFilterService.getFilterData('quote-value-approvers',resources),
                    serviceProviderResponse: advancedFilterService.getFilterData('quoteServiceProviders',resources),
                    regionCollectionResponse: advancedFilterService.getFilterData('quote-regions',resources),
                    creatorsCollectionResponse: advancedFilterService.getFilterData('quoteCreators',resources),
                    siteGroupCollection: advancedFilterService.getFilterData('siteGroups',resources),
                    siteCollection: resources.sites,
                    coreClientsCollectionResponse: advancedFilterService.getFilterData('coreclients',resources),
                    serviceProviderGroupsResponse: advancedFilterService.getFilterData('serviceProviderGroups',resources)
                }
            });
        }
    };
}]);
